import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import {
    withStyles,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from '@material-ui/core';
import { getTranslate } from 'react-localize-redux';

const styles = theme => ({
    root: {
        width: theme.spacing(23),
    },
    selectMenu: {
        top: 50,
    },
});

const weekDays = ['1', '2', '3', '4', '5'];

class WeekdaySelect extends React.Component {
    renderWeekdays = (days) => {
        const trim = days.length < 3 ? undefined : 3;
        return days
            .map(day => this.props.translate(`time.weekdays.${day}`).slice(0, trim))
            .join(', ');
    }

    render() {
        const {
            classes, className, translate, value, onChange,
        } = this.props;

        return (
            <FormControl className={classnames(classes.root, className)}>
                <InputLabel
                    htmlFor="availableWeekdays"
                    shrink
                >
                    {translate('studentEdit.availableWeekdays')}
                </InputLabel>
                <Select
                    id="availableWeekdays"
                    multiple
                    value={value}
                    onChange={onChange}
                    renderValue={this.renderWeekdays}
                    MenuProps={{
                        className: classes.selectMenu,
                    }}
                >
                    {weekDays.map(day => (
                        <MenuItem key={day} value={day}>{translate(`time.weekdays.${day}`)}</MenuItem>))}
                </Select>
            </FormControl>
        );
    }
}

WeekdaySelect.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
};

WeekdaySelect.defaultProps = {
    className: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(WeekdaySelect));
